var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 17.9999,
    height: 16.8,
    viewBox: "0 0 17.9999 16.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00002 0C4.02917 0 0 3.11296 0 6.95228C0 9.34003 1.5584 11.445 3.93152 12.697L2.93303 16.3445C2.84481 16.6668 3.21341 16.9237 3.49646 16.7369L7.87334 13.8482C8.2427 13.8838 8.61808 13.9046 9.00002 13.9046C13.9705 13.9046 17.9999 10.7918 17.9999 6.95228C17.9999 3.11296 13.9705 0 9.00002 0",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.38c63b08906ceb2671b91f8fc240d6ab.svg";
export { ForwardRef as ReactComponent };